import React from 'react';
import cn from 'classnames';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import FavouriteButton from '../../buttons/FavouriteButtonWithPopover';
import CommentButton from '../../buttons/CommentButton';
import AddToGroupButton from '../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../buttons/MoreButton';
import DeleteButton from '../../buttons/DeleteButton';
import EditButton from '../../buttons/EditButton';
import AwardBadgeButton from '../../buttons/AwardBadgeButton';
import AdoptableSeller from '../../buttons/AdoptableSeller';
import AddToPrivateCollectionButtonWithPopover from '../../buttons/AddToPrivateCollectionButtonWithPopover';
import AdoptableBuyer from '../../buttons/AdoptableBuyer';
import OrderCommissionButton from '../../buttons/OrderCommissionButton';
import FreeDownloadButton from '../../buttons/DownloadButton/FreeDownloadButton';
import LoginToDownloadButton from '../../buttons/DownloadButton/LoginToDownloadButton';
import SellYourArtLink from '../../buttons/SellYourArtLink';
import CommissionStatusButton from '../../buttons/CommissionStatusButton';
import { StandardDeviationElementPlacement } from '../../ElementPlacementContext/variants/standard/types';
import { StandardDeviationElementPlacementContext } from '../../ElementPlacementContext/variants/standard/context';
import { useElementPlacementForArea } from '../../ElementPlacementContext/utils';
import BoostButton from '../../buttons/BoostButton';
import s from './MobileActionBar.scss';
export const MobileActionBar = ({ deviation, isOwner, className })=>{
    const primaryBarElementPlacement = useElementPlacementForArea(StandardDeviationElementPlacement.PrimaryBar, StandardDeviationElementPlacementContext);
    const secondaryBarElementPlacement = useElementPlacementForArea(StandardDeviationElementPlacement.SecondaryBar, StandardDeviationElementPlacementContext);
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        className: cn(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['icons-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-block']
    }, primaryBarElementPlacement.favourite && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(FavouriteButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), primaryBarElementPlacement.comment && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner
    })), primaryBarElementPlacement.addToGroup && !primaryBarElementPlacement.meta.hasPrimaryMoreActionsMenu && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-block']
    }, primaryBarElementPlacement.orderCommission && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(OrderCommissionButton, {
        deviation: deviation
    })), primaryBarElementPlacement.privateCollection && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AddToPrivateCollectionButtonWithPopover, {
        deviation: deviation
    })), /**
             * The "add to group" button can be in two different spots on the primary bar depending on
             * if the more menu is present.
             *
             * NOTE: We shouldn't use this method to swap controls between bars or the more menu. That's what
             * our {@link StandardDeviationElementPlacementMap} is for. However, this is fine to check against if we're
             * only moving it around within the domain of the indicated area. (e.g. if {@link StandardDeviationElementPlacementMap}
             * has a control appearing in {@link StandardDeviationElementPlacement.PrimaryBar}, it's fine to move the
             * control around inside the primary bar, but it's not fine to have it jump to the secondary bar. Alter the
             * rules inside {@link StandardDeviationElementPlacementMap} instead if you need that behaviour)
             */ primaryBarElementPlacement.addToGroup && primaryBarElementPlacement.meta.hasPrimaryMoreActionsMenu && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation
    })), primaryBarElementPlacement.awardBadge && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(AwardBadgeButton, {
        deviation: deviation
    })), primaryBarElementPlacement.freeDownload && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(FreeDownloadButton, {
        deviation: deviation
    })), primaryBarElementPlacement.boostDeviation && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(BoostButton, {
        deviation: deviation
    })), primaryBarElementPlacement.meta.hasPrimaryMoreActionsMenu && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })), primaryBarElementPlacement.deleteDeviation && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    })), primaryBarElementPlacement.editDeviation && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })), primaryBarElementPlacement.commissionStatus && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(CommissionStatusButton, {
        deviation: deviation
    })))), /*#__PURE__*/ React.createElement("div", {
        className: s['download-button-row']
    }, secondaryBarElementPlacement.sellDeviation && /*#__PURE__*/ React.createElement(SellYourArtLink, {
        deviation: deviation
    }), secondaryBarElementPlacement.freeDownload && /*#__PURE__*/ React.createElement(LoginToDownloadButton, {
        className: s['full-width'],
        deviation: deviation
    }), secondaryBarElementPlacement.elementGroups.adoptableSeller.groupPlacement && /*#__PURE__*/ React.createElement(AdoptableSeller, {
        deviation: deviation
    }), secondaryBarElementPlacement.elementGroups.adoptableBuyer.groupPlacement && /*#__PURE__*/ React.createElement(AdoptableBuyer, {
        deviation: deviation
    })));
};
MobileActionBar.displayName = 'MobileActionBar';
export default MobileActionBar;

//# sourceMappingURL=MobileActionBar.js.map